
import { defineComponent } from "vue";
import { Tab, Tabs, Swipe, SwipeItem } from "vant";
export default defineComponent({
    components: {
        [Tab.name]: Tab,
        [Tabs.name]: Tabs,
        [Swipe.name]: Swipe,
        [SwipeItem.name]: SwipeItem
    },
    setup() {
        return {};
    },
});
